import { jsxs as f } from "react/jsx-runtime";
import { forwardRef as x, useMemo as v, cloneElement as z } from "react";
import { c as i } from "./tw-cn-mXgPecoF.mjs";
import { c as s } from "./index-BpNK5r1N.mjs";
const S = s(
  [
    "inline-flex items-center justify-center align-middle",
    "select-none appearance-none py-4 ",
    "aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:border-0"
  ],
  {
    variants: {
      mobileSize: {
        large: "min-h-40 typography-subtitle-16-regular",
        medium: "min-h-38 typography-body-14-regular",
        small: "min-h-34 typography-body-12-regular"
      },
      pcSize: {
        large: "pc:min-h-40 pc:typography-subtitle-16-regular",
        medium: "pc:min-h-38 pc:typography-body-14-regular",
        small: "pc:min-h-34 pc:typography-body-12-regular"
      },
      theme: {
        default: [""],
        underline: ["underline [text-decoration-skip-ink:none] [text-underline-offset:0.2rem]"]
      },
      weight: {
        regular: "",
        bold: "!font-bold"
      },
      transparent: {
        true: [
          "bg-transparent text-static-white",
          "hover-never:bg-interaction-transparent-presshover-main active:bg-interaction-transparent-presshover-main",
          "aria-disabled:text-interaction-transparent-disable-main"
        ],
        false: [
          "text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
          "aria-disabled:text-interaction-neutral-disable-main"
        ]
      }
    },
    defaultVariants: {
      mobileSize: "medium",
      pcSize: "large",
      theme: "default",
      weight: "regular",
      transparent: !1
    }
  }
), w = s("", {
  variants: {
    mobileSize: {
      large: "size-18",
      medium: "size-16",
      small: "size-14"
    },
    pcSize: {
      large: "pc:size-18",
      medium: "pc:size-16",
      small: "pc:size-14"
    }
  },
  defaultVariants: {
    mobileSize: "medium",
    pcSize: "large"
  }
}), N = x(
  ({
    theme: l = "default",
    disabled: t = !1,
    transparent: o = !1,
    mobileSize: a = "medium",
    pcSize: r = "large",
    weight: m = "regular",
    ...c
  }, p) => {
    const { children: u, type: d = "button", icon: e, className: g, ...b } = c, h = S({
      theme: l,
      mobileSize: a,
      pcSize: r,
      weight: m,
      transparent: !!o
    }), n = w({ mobileSize: a, pcSize: r }), y = v(
      () => e ? z(e, { className: i(n, e.props.className) }) : null,
      [e, n]
    );
    return /* @__PURE__ */ f(
      "button",
      {
        "aria-disabled": t,
        className: i(h, g),
        disabled: t,
        ref: p,
        tabIndex: t ? -1 : 0,
        type: d,
        ...b,
        children: [
          u,
          y
        ]
      }
    );
  }
);
N.displayName = "NDS.TextButton";
export {
  N as T
};
